import { render } from "./person-nationality-attachment.vue?vue&type=template&id=1f55a2cc"
import script from "./person-nationality-attachment.vue?vue&type=script&lang=js"
export * from "./person-nationality-attachment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__